import { render, staticRenderFns } from "./SvehiclesalesreceiptIndex.vue?vue&type=template&id=cd685d92"
import script from "./SvehiclesalesreceiptIndex.vue?vue&type=script&lang=js"
export * from "./SvehiclesalesreceiptIndex.vue?vue&type=script&lang=js"
import style0 from "./SvehiclesalesreceiptIndex.vue?vue&type=style&index=0&id=cd685d92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports